import { useEffect, useState } from "react";
import { useDealer } from "../../../../../tools/api";
import { NotFound } from "../../../../../sources/svg/svg";
import { Table } from "antd";
import { convertToJalaliWithTime } from "../../../../../tools/tools";

const ChangeSimCard = ({ sppurchaseid = 0 }) => {
  const { querySWPurchaseBySPPurchaseId } = useDealer();

  const [listSwap, setListSwap] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const [isLoadingList, setIsLoadingList] = useState(true);

  useEffect(() => {
    const initial = async () => {
      setIsLoadingList(true);
      try {
        const payloadSwap = {
          SPPurchaseId: sppurchaseid,
          search: {
            sort: "",
            filter: "",
            entriesperpage: 10,
            page: currentPage === 0 ? 0 : currentPage - 1,
            totalrowcount: 0,
          },
        };
        const responseSwap = await querySWPurchaseBySPPurchaseId(payloadSwap);
        if (responseSwap) {
          setListSwap(responseSwap?.Result);
          setTotalRecord(responseSwap?.searchconfigmodel?.totalrowcount);
        }
        setIsLoadingList(false);
      } catch (error) {
        setIsLoadingList(false);
        console.log(error?.message);
      }
    };
    if (sppurchaseid) initial();
  }, [sppurchaseid, currentPage]);
  return (
    <>
      <div className="holder-table" style={{ marginTop: "3rem" }}>
        <Table
          className="tbl-normal"
          loading={isLoadingList}
          columns={[
            {
              title: "کیت قبلی",
              dataIndex: "oLDICCID",
              key: "oLDICCID",
              width: 150,
            },
            {
              title: "کیت جدید",
              dataIndex: "nEWICCID",
              key: "nEWICCID",
              width: 150,
            },
            {
              title: "تاریخ",
              dataIndex: "operationDate",
              key: "operationDate",
              width: 150,
            },
            {
              title: "وضعیت درخواست",
              dataIndex: "simswapstate",
              key: "simswapstate",
              width: 150,
            },
            {
              title: "علت درخواست",
              dataIndex: "simswapReason",
              key: "simswapReason",
              width: 150,
            },
          ]}
          locale={{
            emptyText: (
              <>
                <NotFound text={"رکوردی یافت نشد."} />
              </>
            ),
          }}
          scroll={{ y: "100%" }}
          pagination={{
            className: "page-pagination",
            // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10,
            align: "start",
            current: currentPage === 0 ? 1 : currentPage,
            total: totalRecord,
            showSizeChanger: false,
          }}
          dataSource={listSwap.map((item, key) => ({
            key: key,
            oLDICCID: item?.oLDICCID?.slice(10, 19),
            nEWICCID: item?.nEWICCID?.slice(10, 19),
            operationDate: convertToJalaliWithTime(item?.operationDate),
            simswapstate: item?.simswapstate,
            simswapReason: item?.simswapReason,
          }))}
        />
      </div>
    </>
  );
};

export default ChangeSimCard;
